export default (title?: string) => {
  if (title) return title;
};
